__turbopack_context__.v({
  "productsGrid": "ProductsGrid-module__eYV9Iq__productsGrid",
});
